module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-off",
    class: {
      'noBottom': _vm.currentPart == 0
    }
  }, [_c('div', {
    attrs: {
      "id": "slider"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.sliderLists), function(sliderList, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "slider-item",
      class: {
        'slider-item-active': index == _vm.currentPart
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changePart(index)
        }
      }
    }, [_c('a', {
      staticClass: "anchor",
      class: {
        'anchor-active': index == _vm.currentPart
      },
      attrs: {
        "href": '#anchor-' + index
      }
    }, [_vm._v(_vm._s(sliderList.title))])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "slider-right",
    attrs: {
      "id": "slider-right"
    },
    on: {
      "click": _vm.showAllPart
    }
  }, [_c('div', {
    staticClass: "slider-triangle-down"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583e7612","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/sliderOff.vue
// module id = 116
// module chunks = 1